module.exports = __webpack_public_path__ + "img/jiaotongyh.25fc7b00.png";